
interface IProps {
  color?: string;
  size?: number;
}

export const FacebookSquareRounded = ({size=45, color="#12121B"}: IProps) => (
  <svg width={size} height={size} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={size} height={size} rx="8" fill={color}/>
    <path d="M24 24.5H26.5L27.5 20.5H24V18.5C24 17.47 24 16.5 26 16.5H27.5V13.14C27.174 13.097 25.943 13 24.643 13C21.928 13 20 14.657 20 17.7V20.5H17V24.5H20V33H24V24.5Z" fill="white"/>
  </svg>
)